import {useEffect,useState} from 'react'
import {apiGet} from '../api/client'
import type {Envelope,RevisionSummary} from '../api/types'
import Icon from '../icons'
import PreviewImage from './PreviewImage'
type Citation=Record<string,unknown>
/** Fetch the authorized logical baseline view; physical page identities and
 * object keys are never reconstructed by the client. */
export default function KnowledgeImageMatches({citations,onPreview}:{citations:Citation[];onPreview:(citation:Citation)=>void}){
 const [previews,setPreviews]=useState<Record<string,string>>({})
 const targets=citations.filter(row=>typeof row.asset_id==='string'&&typeof row.revision_id==='string'&&typeof row.page_ref==='string').slice(0,6)
 const key=targets.map(row=>`${row.asset_id}:${row.revision_id}:${row.page_ref}`).join('|')
 useEffect(()=>{
  let active=true;setPreviews({})
  const groups=[...new Map(targets.map(row=>[String(row.asset_id)+':'+String(row.revision_id),row])).values()]
  void Promise.allSettled(groups.map(async row=>{
   const result=await apiGet<Envelope<RevisionSummary[]>>(`/assets/${encodeURIComponent(String(row.asset_id))}/revisions`,{revision_id:String(row.revision_id),limit:1})
   const revision=result.data.find(item=>item.id===row.revision_id&&item.asset_id===row.asset_id&&item.status==='effective')
   if(!active||!revision)return
   const urls=Object.fromEntries(targets.filter(item=>item.asset_id===row.asset_id&&item.revision_id===row.revision_id).flatMap(item=>{
    const page=revision.preview_pages?.find(page=>page.page_ref===item.page_ref)
    return page?.preview_url?[[`${item.asset_id}:${item.revision_id}:${item.page_ref}`,page.preview_url]]:[]
   }))
   setPreviews(current=>({...current,...urls}))
  }))
  return()=>{active=false}
 },[key])
 if(!targets.length)return null
 return <section className="knowledge-image-matches" aria-label="相似图片素材"><div className="knowledge-image-matches-heading"><b>相似素材</b><span>点击原页查看，视觉相似度不代表业务适用性</span></div><div>{targets.map((row,index)=>{
  const id=`${row.asset_id}:${row.revision_id}:${row.page_ref}`
  return <button type="button" className="knowledge-image-match" key={id} onClick={()=>onPreview(row)}><span className="knowledge-image-match-cover">{previews[id]?<PreviewImage src={previews[id]} alt={String(row.asset_name??'素材预览')}/>:<Icon name="image" size={28}/>}</span><b>[{index+1}] {String(row.asset_name??'知识库素材')}</b><small>第 {Number(String(row.page_ref).slice(1))||'—'} 页 · 弹窗预览</small></button>
 })}</div></section>
}
